$(document).ready(function (e) {
    // SP drawer menu
    $("#js-nav-drawer-open").on("click", function () {
        $("#js-nav-drawer").addClass("active");
        $("#js-nav-drawer-overlay").addClass("active");
        $(".nav-drawer__container").show();
        scrollPosition = $(window).scrollTop();
        $("body").addClass("fixed").css({ top: -scrollPosition });
    });
    $("#js-nav-drawer-close").on("click", function () {
        $("#js-nav-drawer").removeClass("active");
        $("#js-nav-drawer-overlay").removeClass("active");
        $("body").removeClass("fixed").css({ top: 0 });
        window.scrollTo(0, scrollPosition);
    });

    // FIX Footer Control
    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 50) {
            $("#js-nav-fixfooter__container").slideDown(100);
            $(".js-nav-fixfooter__button-memo").stop().animate({ marginRight: "86px" }, 100);
            $("#js-nav-pagetop").stop().animate({ marginRight: "60px" }, 100);
        } else {
            $("#js-nav-fixfooter__container").slideUp(100);
            $(".js-nav-fixfooter__button-memo").stop().animate({ marginRight: "0" }, 100);
            $("#js-nav-pagetop").stop().animate({ marginRight: "0" }, 100);
        }
    });

    // Smooth Scroll
    const headerHeight = $("header").outerHeight();
    // link from : other page xxx.html
    const urlHash = location.hash;
    if (urlHash) {
        $("body,html").stop().scrollTop(0);
        setTimeout(function () {
            const target = $(urlHash);
            const position = target.offset().top - headerHeight;
            $("body,html").stop().animate({ scrollTop: position }, 500);
        }, 100);
    }
    // link from : same page #id
    $('a[href^="\\/#"]').click(function () {
        const href = $(this).attr("href");
        const target = $(href.replace(/\//g, ""));
        const position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, 500);
    });
    // page-top : #
    $('a[href^="#"],area').click(function () {
        const href = $(this).attr("href");
        const target = $(href === "#" || href === "" ? "html" : href);
        const position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, 500);
    });

    //Page Effect
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("edge") != -1) {
        scroll_effect();
    }
    $(window).on("load scroll", function () {
        scroll_effect();
    });
    function scroll_effect() {
        $(".effect-fade").each(function () {
            const elemPos = $(this).offset().top;
            const scroll = $(window).scrollTop();
            const windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100) {
                $(this).addClass("effect-scroll");
            }
        });
    }

    // パスワード切り替え
    $(".form__password-eye").on("click", function () {
        $(this).toggleClass("fa-eye fa-eye-slash");
        const input = $(this).prev("input");
        if (input.attr("type") === "text") {
            input.attr("type", "password");
        } else {
            input.attr("type", "text");
        }
    });

    // ボタンを有効にする。
    modalWindow.enableButton();

    // inputでEnterを押したときにSubmitさせない
    window.addEventListener("keydown", function (event) {
        if (event.key === "Enter" && event.target.tagName === "INPUT") {
            event.preventDefault();
        }
    });

    // ポップアップをクローズ
    $(".js-popup-close").on("click", function () {
        $(".js-popup").fadeOut(50);
    });
});

/**
 * 基本的な関数たち
 */
const modalWindow = {
    // モーダル表示
    showModal: function (obj) {
        $(obj).fadeIn();
        $(obj).addClass("active");
        $(".modal__overlay").data("modal-id", obj);
        if (obj !== "#js-modal-delete") {
            scrollPosition = $(window).scrollTop();
            $("body").addClass("fixed").css({ top: -scrollPosition });
        }
        return false;
    },
    // モーダル非表示
    hideModal: function () {
        const obj = $(".modal__overlay").data("modal-id");

        $(obj).fadeOut();
        $(obj).children($(".modal__overlay")).removeClass("active");
        if (obj !== "#js-modal-delete") {
            $("body").removeClass("fixed").css({ top: 0 });
            window.scrollTo(0, scrollPosition);
        }
        return false;
    },
    enableButton: function () {
        // 表示
        $(".js-modal-show").unbind();
        $(".js-modal-show").click(function () {
            const target = $(this).data("target");
            modalWindow.showModal(target);
        });

        //非表示
        $(".js-modal-hide, .modal__overlay").unbind();
        $(".js-modal-hide, .modal__overlay").click(function () {
            modalWindow.hideModal();
        });
    }
};
window.modalWindow = modalWindow;
